module.exports = __webpack_public_path__ + "e2c68bdcbb8835c922f5a45ea643659f.png";